// Enum: lime.ui.MouseCursor

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

// Imports

var $estr = require("./../../estr_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;

// Definition

var MouseCursor = $hxEnums["lime.ui.MouseCursor"] = { __ename__ : "lime.ui.MouseCursor", __constructs__ : ["ARROW","CROSSHAIR","DEFAULT","MOVE","POINTER","RESIZE_NESW","RESIZE_NS","RESIZE_NWSE","RESIZE_WE","TEXT","WAIT","WAIT_ARROW","CUSTOM"]
  ,WAIT_ARROW: {_hx_index:11,__enum__:"lime.ui.MouseCursor",toString:$estr}
  ,WAIT: {_hx_index:10,__enum__:"lime.ui.MouseCursor",toString:$estr}
  ,TEXT: {_hx_index:9,__enum__:"lime.ui.MouseCursor",toString:$estr}
  ,RESIZE_WE: {_hx_index:8,__enum__:"lime.ui.MouseCursor",toString:$estr}
  ,RESIZE_NWSE: {_hx_index:7,__enum__:"lime.ui.MouseCursor",toString:$estr}
  ,RESIZE_NS: {_hx_index:6,__enum__:"lime.ui.MouseCursor",toString:$estr}
  ,RESIZE_NESW: {_hx_index:5,__enum__:"lime.ui.MouseCursor",toString:$estr}
  ,POINTER: {_hx_index:4,__enum__:"lime.ui.MouseCursor",toString:$estr}
  ,MOVE: {_hx_index:3,__enum__:"lime.ui.MouseCursor",toString:$estr}
  ,DEFAULT: {_hx_index:2,__enum__:"lime.ui.MouseCursor",toString:$estr}
  ,CUSTOM: {_hx_index:12,__enum__:"lime.ui.MouseCursor",toString:$estr}
  ,CROSSHAIR: {_hx_index:1,__enum__:"lime.ui.MouseCursor",toString:$estr}
  ,ARROW: {_hx_index:0,__enum__:"lime.ui.MouseCursor",toString:$estr}
};

exports.default = MouseCursor;